import Request from "@gcloud-npm/utils.fetch";
import { findOutEnvByEnvName } from "@gcloud-npm/utils.enums.environment";
import Sonda from '@gcloud-npm/utils.monitoring.sonda';
import getUUID from "@gcloud-npm/utils.monitoring.get-uuid";
import { PROCESS_NAME } from "@gcloud-npm/utils.adabyron.make-up-telco-path-name";

const EVENT_NAME = "MISC.SEND_RETARGETING";

export function sendRetargeting({ data, context: appContext, envName=`${process.env.NEXT_PUBLIC_ENV_NAME}`, idFront = "VT", logged = false, requestId }) {
  const { campaign, contactInfo, products, context, recaptchaToken, additionalInfo } = data;
  
  const myContext = {
    ...appContext,
    environment: findOutEnvByEnvName(envName),
  };

  const { 'abs-layer': connectionData } = myContext.environment;
  const { endpoint:host } = connectionData;

  let URL_API = `${host}/movistar-layer/api/open/retargeting/v1/collect-info`;

  if(logged){
    URL_API = 'https://www.movistar.es/movistar-layer/api/client/retargeting/v1/collect-info';
  }

  const idRequest = getUUID(idFront, '', false);

  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context: myContext,
    uniqueId: `idPeticion=${idRequest}`,
    origin: PROCESS_NAME.CLIENT,
  });

  let dataToSend = { campaign, contactInfo, products, context, additionalInfo };

  dataToSend.requestId = requestId;

  const request = new Request({
    method: "POST",
    endpoint: URL_API,
    data: dataToSend,
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Accept: "application/json",
      "X-Recaptcha-Token": recaptchaToken,
      withCredentials: true,
    },
    sonda,
  });
  return request.makeRequest();
}

export default sendRetargeting;